module.exports = __webpack_public_path__ + "img/8.001cac68.png";